import { render, staticRenderFns } from "./assignRole.vue?vue&type=template&id=fe5060ba&scoped=true"
import script from "./assignRole.vue?vue&type=script&lang=js"
export * from "./assignRole.vue?vue&type=script&lang=js"
import style0 from "./assignRole.vue?vue&type=style&index=0&id=fe5060ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5060ba",
  null
  
)

export default component.exports